import {query,queryOne,queryAll,queryPage,add,plus,submit,invalid,update,upload} from '@/common/http'
import {substr,join,fill,properties} from '@/common/util'
import {Constants} from '@/common/constants'

export default {
    install(Vue) {
        // http
        Vue.prototype.$query = query
        Vue.prototype.$queryOne = queryOne
        Vue.prototype.$queryAll = queryAll
        Vue.prototype.$queryPage = queryPage
        Vue.prototype.$add = add
        Vue.prototype.$plus = plus
        Vue.prototype.$submit = submit
        Vue.prototype.$invalid = invalid
        Vue.prototype.$update = update
        Vue.prototype.$upload = upload
        // util
        Vue.prototype.$substr = substr
        Vue.prototype.$join = join
        Vue.prototype.$fill = fill
        Vue.prototype.$properties = properties
        // constants
        Vue.prototype.$constant = Constants
    },
  }